export const TakeoffSoftwares = {
    Excel: { id: "1", text: "Excel File", i18nKey: "ExcelFile" },
    ExtrAXION: { id: "2", text: "ExtrAXION (Alconsoft)", i18nKey: "ExtraxionAlconsoft" }
}